import { usePatientFeatureFlags } from "../hooks/usePatientFeatureFlags";
import { useEffect } from "react";
import { wasReviewPopupDismissed } from "./reviewPopup";
import { usePatient } from "../state/patientContext";

export const useShowReviewPopup = () => {
  const allowFeedbackPopupFlag = usePatientFeatureFlags("askForFeedbackPopup");

  const { caseId, setShowFeedbackPopup } = usePatient();

  useEffect(() => {
    if (caseId && allowFeedbackPopupFlag && !wasReviewPopupDismissed(caseId)) {
      setTimeout(() => {
        setShowFeedbackPopup(true);
      }, 500);
    }
  }, [caseId, allowFeedbackPopupFlag, setShowFeedbackPopup]);
};
